import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
import red from 'sushiweb/tokens/color/red';

export const StepBarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: default;
`;

export const StepLabel = styled.span`
  font-size: 1.4rem;
  font-weight: ${({ active }) => (active ? '600' : '500')};
  color: ${({ active, completed }) => {
    if (active) return red.z500;
    if (completed) return grey.z700;
    return grey.z600;
  }};
  padding: 0 1.6rem 0.8rem 1.6rem;
  border-bottom: 2px solid
    ${({ active }) => (active ? red.z500 : 'transparent')};
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`;

export const StepConnector = styled.div`
  width: 3rem;
  height: 1px;
  background: ${grey.z200};
  margin-bottom: 0.8rem;
`;
